import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TeamArea from "../components/TeamArea";
import Chat from "../components/Chat";

const testimonials = [
  {
    text: "Sagama Construction delivered our dream home on time and within budget. Their attention to detail and professionalism are unparalleled.",
    name: "Mrs. Adebayo",
    designation: "CEO of Maithon",
  },
  {
    text: "We were impressed by Sagama's innovative approach to solving complex construction challenges. Their team is knowledgeable and responsive.",
    name: "Engr. Ibrahim",
    designation: "CEO of Goston",
  },
  {
    text: "Sagama's commitment to safety and quality is evident in every aspect of their work. We're proud to have partnered with them.",
    name: "Arc. Ahmed",
    designation: "CEO of Gogonti",
  },
];

const About = () => {
  return (
    <>
      {/* Internal styles for the page */}
      <style>{`
        /* Breadcrumb */
        .breadcumb-wrapper {
          background-size: cover;
          background-position: center;
          padding: 120px 0 80px;
          position: relative;
        }
        .breadcumb-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #fff;
        }
        .breadcumb-menu {
          color: #e86b24;
        }
        .breadcumb-menu a {
          color: rgba(255,255,255,0.8);
          text-decoration: none;
        }

        /* About intro section */
        .about-title {
          font-size: 2rem;
          font-weight: 700;
          color: #0a1a3d;
          margin-bottom: 1rem;
        }
        .about-text {
          font-size: 0.95rem;
          line-height: 1.7;
          color: #555;
          margin-bottom: 1.8rem;
        }
        .pillar-card {
          background: #f9f9f9;
          border-radius: 10px;
          padding: 20px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          gap: 15px;
        }
        .pillar-icon img {
          width: 40px;
          height: 40px;
        }
        .pillar-title {
          font-size: 1rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.2rem;
        }
        .pillar-text {
          font-size: 0.85rem;
          color: #666;
          margin: 0;
        }

        /* Standardised stats */
        .stats-section {
          background: #0a1a3d;
          padding: 3rem 0;
        }
        .stat-card {
          text-align: center;
          color: #fff;
          padding: 20px;
        }
        .stat-number {
          font-size: 2.5rem;
          font-weight: 700;
          color: #e86b24;
        }
        .stat-label {
          font-size: 1rem;
          color: rgba(255,255,255,0.9);
          text-transform: none;
        }

        /* Mission & Vision cards */
        .mission-vision-section {
          padding: 3rem 0;
          background: #f9f9f9;
        }
        .mission-vision-card {
          background: #fff;
          border-radius: 12px;
          padding: 30px;
          height: 100%;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
        }
        .mission-vision-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 1rem;
        }
        .mission-vision-card p {
          font-size: 0.95rem;
          color: #555;
          line-height: 1.6;
        }

        /* Process steps – The Sagama Standard */
        .process-card-new {
          text-align: center;
          padding: 30px 20px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.06);
          transition: transform 0.3s;
          height: 100%;
        }
        .process-card-new:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0,0,0,0.1);
        }
        .process-card-new .step-number {
          font-size: 2rem;
          font-weight: 700;
          color: #e86b24;
          margin-bottom: 0.5rem;
        }
        .process-card-new h4 {
          font-size: 1.1rem;
          font-weight: 600;
          color: #0a1a3d;
          margin-bottom: 0.5rem;
        }
        .process-card-new p {
          font-size: 0.9rem;
          color: #666;
          line-height: 1.5;
        }

        /* CTA */
        .cta-section-about {
          background: #e86b24;
          color: #fff;
          padding: 3rem 0;
          text-align: center;
        }
        .cta-section-about h2 {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 1.5rem;
        }
        .cta-buttons {
          display: flex;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
        }
        .cta-btn {
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s;
          text-decoration: none;
        }
        .cta-btn-primary {
          background: #fff;
          color: #e86b24;
          border: 2px solid #fff;
        }
        .cta-btn-primary:hover {
          background: transparent;
          color: #fff;
        }
        .cta-btn-outline {
          background: transparent;
          color: #fff;
          border: 2px solid #fff;
        }
        .cta-btn-outline:hover {
          background: #fff;
          color: #e86b24;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .about-title {
            font-size: 1.6rem;
          }
          .stat-number {
            font-size: 2rem;
          }
          .cta-section-about h2 {
            font-size: 1.6rem;
          }
        }
      `}</style>

      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">About Us</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>About Us</li>
            </ul>
          </div>
        </div>
      </div>

      <Chat />

      {/* About Intro – Fixed headline & copy */}
      <div className="space overflow-hidden" id="about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6">
              <div className="img-box1">
                <div className="img1">
                  <img
                    className="tilt-active"
                    src="assets/img/main/about_1_1.png"
                    alt="About"
                  />
                </div>
                <div className="about-grid">
                  <h3 className="about-grid_year">
                    <span className="counter-number">25</span>
                    <span>+</span>
                  </h3>
                  <p className="about-grid_text">
                    Years of Engineering Excellence
                  </p>
                </div>
                <div className="img2">
                  <img
                    className="tilt-active"
                    src="assets/img/main/h4.png"
                    alt="About"
                  />
                </div>
                <div
                  className="shape-mockup about-shape1 jump"
                  data-left="-67px"
                  data-bottom={0}
                >
                  <img src="assets/img/main/about_1_shape1.png" alt="img" />
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="title-area mb-30">
                <span className="sub-title4">About Sagama Homes</span>
                <h2 className="sec-title fw-semibold about-title">
                  Building Your Vision. Securing Your Future.
                </h2>
              </div>
              <p className="about-text">
                Sagama Homes is a premier, privately-owned real estate developer
                dedicated to creating signature residential and commercial
                properties. We don’t just build houses; we curate exclusive
                lifestyles. By combining modern aesthetics with unparalleled
                structural integrity, we have risen to become one of Abuja's
                most trusted real estate brands. From the foundation to the
                final coat of paint, our meticulous attention to detail ensures
                your home is secure, beautiful, and delivered exactly on time.
              </p>
              <div className="pillar-card">
                <div className="pillar-icon">
                  <img src="assets/img/icon/about-grid-icon1.svg" alt="icon" />
                </div>
                <div>
                  <h5 className="pillar-title">Diaspora-Trusted Services</h5>
                  <p className="pillar-text">
                    Transparent online processing, 3D inspections, and dedicated
                    account managers for Nigerians living abroad.
                  </p>
                </div>
              </div>
              <div className="pillar-card">
                <div className="pillar-icon">
                  <img src="assets/img/icon/about-grid-icon2.svg" alt="icon" />
                </div>
                <div>
                  <h5 className="pillar-title">Award-Winning Quality</h5>
                  <p className="pillar-text">
                    Backed by decades of heavy civil engineering expertise, our
                    structures are built to withstand the test of time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Standardised Stats (no fake numbers) */}
      <section className="stats-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-4 stat-card">
              <h3 className="stat-number">18+</h3>
              <p className="stat-label">Estates Developed</p>
            </div>
            <div className="col-md-4 stat-card">
              <h3 className="stat-number">126+</h3>
              <p className="stat-label">Happy Clients</p>
            </div>
            <div className="col-md-4 stat-card">
              <h3 className="stat-number">89+</h3>
              <p className="stat-label">Professionals</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section (static) */}
      <section className="mission-vision-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="mission-vision-card">
                <h3>Our Mission</h3>
                <p>
                  To enrich lives by developing premium, secure, and highly
                  functional real estate that appreciates in value.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mission-vision-card">
                <h3>Our Vision</h3>
                <p>
                  To be the preferred real estate partner in Nigeria, known for
                  our uncompromising quality, transparency, and customer-first
                  approach.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Sagama Standard (replaces Cost Effective Strategy) */}
      <section className="space">
        <div className="container">
          <div className="title-area text-center">
            <h2 className="sec-title fw-semibold">
              The Sagama Standard: Our Commitment to You
            </h2>
          </div>
          <div className="row gy-4 justify-content-center">
            <div className="col-md-6 col-lg-3">
              <div className="process-card-new">
                <div className="step-number">01</div>
                <h4>Strategic Planning</h4>
                <p>
                  We carefully select high-appreciation zones in Abuja to ensure
                  your investment grows while offering a serene living environment.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="process-card-new">
                <div className="step-number">02</div>
                <h4>Uncompromising Engineering</h4>
                <p>
                  We implement rigorous quality control. Our experienced
                  professionals oversee every brick laid, ensuring international
                  safety standards.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="process-card-new">
                <div className="step-number">03</div>
                <h4>Transparent Execution</h4>
                <p>
                  No hidden fees and no sudden delays. We provide transparent
                  timelines and keep you updated at every stage of construction.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <div className="process-card-new">
                <div className="step-number">04</div>
                <h4>Timely Handover</h4>
                <p>
                  Your time is valuable. We pride ourselves on delivering your
                  dream home strictly on schedule, ready for you to move in.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Area – unchanged */}
      <TeamArea />

      {/* Testimonials */}
      <section className="testi-area-3 bg-smoke space">
        <div className="container">
          <div className="title-area text-center">
            <span className="sub-title4">Our Testimonials</span>
            <h2 className="sec-title">What Our Clients Say?</h2>
          </div>
        </div>
        <div className="container">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={3}
            spaceBetween={30}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              1200: { slidesPerView: 3 },
              992: { slidesPerView: 2 },
              768: { slidesPerView: 1 },
            }}
            className="testi-slider3"
          >
            {testimonials.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="testi-card style3">
                  <div className="testi-card-icon">
                    <img src="assets/img/icon/testi-quote3.svg" alt="quote" />
                  </div>
                  <p className="testi-card_text">
                    <span className="text-theme">“</span>
                    {item.text}
                    <span className="text-theme">”</span>
                  </p>
                  <div className="testi-card_content">
                    <div className="testi-card_img"></div>
                    <div className="testi-card_bottom">
                      <h3 className="testi-card_name">{item.name}</h3>
                      <span className="testi-card_desig">{item.designation}</span>
                      <div className="testi-card_review">
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                        <i className="fa fa-star" />
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section-about">
        <div className="container">
          <h2>Ready to Own Your Piece of Abuja?</h2>
          <div className="cta-buttons">
            <Link to="/estates" className="cta-btn cta-btn-primary">
              View Available Estates
            </Link>
            <Link to="/contact" className="cta-btn cta-btn-outline">
              Talk to an Expert
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;